export default __webpack_public_path__ + "static/media/transaction-sucess-check.58cdd322.svg";